import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostListener,
} from '@angular/core';

@Directive({
    selector: '[appHover]',
    exportAs: 'hover',
    standalone: true,
})
export class HoverDirective {
  hovered = false;

  constructor() {}

  @HostListener('mouseenter', ['$event'])
  onMouseEnter(event: MouseEvent) {
    this.hovered = true;
  }

  @HostListener('mouseleave', ['$event'])
  onMouseLeave(event: MouseEvent) {
    this.hovered = false;
  }
}
